import React, { useState } from 'react';
import { Button } from '@ui';
import ConfirmDialog from '@components/ConfirmDialog/ConfirmDialog';
import { Modal } from '@components/v2/Modal';
import { translate } from '@utils/i18n';
import useEditGenericEventContext from '../../context/useEditGenericEventContext';
function Remove({ onClose, isOpen }) {
    const namespace = 'features.modals.edit_generic_event_modal.modals.remove';
    const { genericEvent, deleteGenericEvent } = useEditGenericEventContext();
    const [deleteFutureEvents, setDeleteFutureEvents] = useState(false);
    const onConfirm = () => {
        void deleteGenericEvent({ deleteFutureEvents });
        onClose();
    };
    if (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.isRecurring) {
        return (React.createElement(Modal, { width: "240", title: translate('title', { namespace }), isOpen: isOpen, onClose: onClose, footer: React.createElement(React.Fragment, null,
                React.createElement(Button, { onClick: onClose }, translate('cancel', { namespace: 'features.commons' })),
                React.createElement(Button, { variant: "primary", onClick: onConfirm }, translate('submit', { namespace: 'features.commons' }))) },
            React.createElement("div", { className: "removeEventModalConfirm" },
                React.createElement("p", null, translate('recurring.description', { namespace })),
                React.createElement("label", { className: "qmb-radio recurrenceRadio" },
                    React.createElement("input", { type: "radio", name: "deleteFutureEvents", checked: !deleteFutureEvents, onChange: () => setDeleteFutureEvents(false) }),
                    translate('recurring.delete_this', { namespace })),
                React.createElement("label", { className: "qmb-radio recurrenceRadio" },
                    React.createElement("input", { type: "radio", name: "deleteFutureEvents", checked: deleteFutureEvents, onChange: () => setDeleteFutureEvents(true) }),
                    translate('recurring.delete_all', { namespace })))));
    }
    return isOpen ? (React.createElement(ConfirmDialog, { isOpen: isOpen, title: translate('title', { namespace }), description: translate('description', { namespace }), yesLabel: translate('confirm', { namespace: 'features.commons' }), onConfirm: onConfirm, onCancel: onClose })) : null;
}
export default Remove;
